export const ID_COLUMN_NAME = 'id';
export const AUTO_GENERATED_COLUMN_NAMES = [ID_COLUMN_NAME, 'createdAt'];
export const RESTRICTED_COLUMN_NAMES = [...AUTO_GENERATED_COLUMN_NAMES];
export const isRestrictedColumnName = (name) => {
    return RESTRICTED_COLUMN_NAMES.includes(name);
};
export const isAutoGeneratedColumnName = (name) => {
    return AUTO_GENERATED_COLUMN_NAMES.includes(name);
};
export const isIdColumnName = (name) => name === ID_COLUMN_NAME;
//# sourceMappingURL=columns.js.map